export default __webpack_public_path__ + "static/media/general-error-waves-second.39dd9ec0.png";